import { useState, useEffect, useMemo } from "react";
import {
  Checkbox,
  Container,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { mindayAPI } from "../services/MinDayService";
import { useFormik } from "formik";
import Select from "react-select";
import Download from "downloadjs";

const MinDayPage = ({ setLoading }) => {
  const [bgroup, setBgroup] = useState([]);
  const [brand, setBrand] = useState([]);
  const [model, setModel] = useState([]);
  const [category, SetCategory] = useState([]);
  const [sub_category, SetSub_Category] = useState([]);
  const [countData, setCountData] = useState(0);
  const [searchData, setSearchData] = useState();
  const maxPage = useMemo(() => Math.ceil(countData / 25000), [countData]);
  const [ArrayNumber, setArrayNumber] = useState([]);

  useEffect(() => {
    const rows = Array.from(Array(maxPage).keys());
    setArrayNumber(rows.map((res) => ({ number: res, check: false })));
  }, [maxPage]);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      mindayAPI.getBGroupItec(),
      mindayAPI.getAllBrandItec(),
      mindayAPI.getAllCategoryItec(),
    ])
      .then(([res1, res2, res3]) => {
        if (res1.status == 200) {
          setBgroup(res1.message);
        }
        if (res2.status == 200) {
          setBrand(res2.message);
        }
        if (res3.status == 200) {
          SetCategory(res3.message);
        }
      })
      .catch((e) => {
        alert(e.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const formik = useFormik({
    initialValues: {
      BGroup_ID: null,
      Brand: null,
      Model: null,
      Category: null,
      Sub_Category: null,
      Product_Code: "",
      Product_Name: "",
      EOL: "",
      Branch: "",
    },
    onSubmit: async (values) => {
      try {
        setLoading(true);
        setCountData(0);
        setSearchData();
        let data = {};
        if (values.BGroup_ID?.value) {
          data.BGroup_ID = values.BGroup_ID.value;
        }
        if (values.Brand?.value) {
          data.Brand = values.Brand.value;
        }
        if (values.Model?.value) {
          data.Model = values.Model.value;
        }
        if (values.Category?.value) {
          data.Category = values.Category.value;
        }
        if (values.Sub_Category?.value) {
          data.Sub_Category = values.Sub_Category.value;
        }
        if (values.Product_Code) {
          data.ProductID = values.Product_Code;
        }
        if (values.Product_Name) {
          data.ProductName = values.Product_Name;
        }
        if (values.EOL) {
          data.EOL = values.EOL;
        }
        if (values.Branch) {
          data.Branch = values.Branch;
        }
        const { message, status } = await mindayAPI.getMinDay(data);
        if (status != 200) throw new Error(message);
        setCountData(message);
        setSearchData(data);
      } catch (error) {
        alert(error.message);
      } finally {
        setLoading(false);
      }
    },
  });
  useEffect(() => {
    if (formik.values.Brand) {
      setLoading(true);
      mindayAPI
        .getAllModelItec({ Brand: formik.values.Brand.value })
        .then((res) => {
          if (res.status == 200) {
            setModel(res.message);
          }
        })
        .catch((e) => {
          alert(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setModel([]);
    }
  }, [formik.values.Brand]);
  useEffect(() => {
    if (formik.values.Category) {
      setLoading(true);
      mindayAPI
        .getAllSubCategoryItec({ Category: formik.values.Category.value })
        .then((res) => {
          if (res.status == 200) {
            SetSub_Category(res.message);
          }
        })
        .catch((e) => {
          alert(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      SetSub_Category([]);
    }
  }, [formik.values.Category]);

  const exportExcel = async ({ name_file, index }) => {
    try {
      if (!searchData) return;
      setLoading(true);
      const response = await mindayAPI.downloadMinDay({
        ...searchData,
        index,
      });

      Download(response.data, name_file, response.headers["content-type"]);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const downloadAll = async () => {
    for (const res of ArrayNumber.filter((res) => !!res.check)) {
      await new Promise((resolve) => setTimeout(resolve, 500));
      const name_file = `minday part ${res.number + 1}.xlsx`;
      await exportExcel({ name_file, index: res.number });
    }
  };

  return (
    <form style={{ marginTop: "7px" }} onSubmit={formik.handleSubmit}>
      <Container
        style={{ paddingLeft: "0", paddingRight: "0", paddingTop: "7px" }}
      >
        <Typography
          component="div"
          style={{
            backgroundColor: "#ffffffe6",
            borderRadius: "15px",
            height: "93vh",
            padding: 4,
          }}
        >
          <div
            style={{
              marginTop: "20px",
              padding: 8,
              borderRadius: "12px",
              border: "1px solid gray",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div style={{ borderRight: "1px solid lightgray", width: "100%" }}>
              <div style={{ padding: "2px 4px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "16px",
                  }}
                >
                  <label htmlFor="Branch Group">
                    กลุ่มของสาขา (Branch Group)
                  </label>
                  <Select
                    id="Branch Group"
                    value={formik.values.BGroup_ID}
                    options={bgroup.map((res) => ({
                      label: res.Name,
                      value: res.ID,
                    }))}
                    placeholder="เลือกกลุ่มสาขา"
                    noOptionsMessage={() => "No Data!"}
                    style={{
                      border: "1px solid lightgray",
                      borderRadius: "5px",
                      padding: "4px 6px",
                    }}
                    onChange={(e) => formik.setFieldValue("BGroup_ID", e)}
                    isClearable
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "16px",
                  }}
                >
                  <label htmlFor="Branch">สาขา (Branch)</label>
                  <input
                    id="Branch"
                    value={formik.values.Branch}
                    placeholder="กรอก Branch เช่น 9,112,1045"
                    style={{
                      border: "1px solid lightgray",
                      borderRadius: "5px",
                      padding: "4px 6px",
                    }}
                    onChange={(e) =>
                      formik.setFieldValue("Branch", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
            <div style={{ borderLeft: "1px solid lightgray", width: "100%" }}>
              <div style={{ padding: "2px 4px" }}>
                <div style={{ display: "flex", gap: 4 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "16px",
                      width: "100%",
                    }}
                  >
                    <label htmlFor="Brand">ยี่ห่อ (Brand)</label>
                    <Select
                      id="Brand"
                      value={formik.values.Brand}
                      options={brand
                        .sort((a, b) => a.Brand?.localeCompare(b.Brand))
                        .map((res) => ({
                          label: res.Brand,
                          value: res.Brand,
                        }))}
                      placeholder="เลือก Brand"
                      noOptionsMessage={() => "No Data!"}
                      style={{
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        padding: "4px 6px",
                      }}
                      onChange={(e) => formik.setFieldValue("Brand", e)}
                      isClearable
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "16px",
                      width: "100%",
                    }}
                  >
                    <label htmlFor="Model">รุ่น (Model)</label>
                    <Select
                      id="Model"
                      value={formik.values.Model}
                      options={model
                        .sort((a, b) => a.Model?.localeCompare(b.Model))
                        .map((res) => ({
                          label: res.Model,
                          value: res.Model,
                        }))}
                      placeholder="เลือก Model"
                      noOptionsMessage={() => "No Data!"}
                      style={{
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        padding: "4px 6px",
                      }}
                      onChange={(e) => formik.setFieldValue("Model", e)}
                      isClearable
                    />
                  </div>
                </div>
              </div>
              <div style={{ padding: "2px 4px" }}>
                <div style={{ display: "flex", gap: 4 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "16px",
                      width: "100%",
                    }}
                  >
                    <label htmlFor="Category">หมวดหมู่ (Category)</label>
                    <Select
                      id="Category"
                      value={formik.values.Category}
                      options={category
                        .sort((a, b) => a.Name?.localeCompare(b.Name))
                        .map((res) => ({
                          label: res.Name,
                          value: res.CategoryID,
                        }))}
                      placeholder="เลือก Category"
                      noOptionsMessage={() => "No Data!"}
                      style={{
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        padding: "4px 6px",
                      }}
                      onChange={(e) => formik.setFieldValue("Category", e)}
                      isClearable
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "16px",
                      width: "100%",
                    }}
                  >
                    <label htmlFor="Sub Category">
                      หมวดหมู่ย่อย (Sub Category)
                    </label>
                    <Select
                      id="Sub Category"
                      value={formik.values.Sub_Category}
                      options={sub_category
                        .sort((a, b) => a.Info8?.localeCompare(b.Info8))
                        .map((res) => ({
                          label: res.Info8,
                          value: res.Info8,
                        }))}
                      placeholder="เลือก Sub Category"
                      noOptionsMessage={() => "No Data!"}
                      style={{
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        padding: "4px 6px",
                      }}
                      onChange={(e) => formik.setFieldValue("Sub_Category", e)}
                      isClearable
                    />
                  </div>
                </div>
              </div>
              <div style={{ padding: "2px 4px" }}>
                <div style={{ display: "flex", gap: 4 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "16px",
                      width: "100%",
                    }}
                  >
                    <label htmlFor="Product Code">
                      {" "}
                      รหัสสินค้า (Product Code)
                    </label>
                    <input
                      id="Product Code"
                      value={formik.values.Product_Code}
                      placeholder="กรอก Product Code"
                      style={{
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        padding: "4px 6px",
                      }}
                      onChange={(e) =>
                        formik.setFieldValue("Product_Code", e.target.value)
                      }
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "16px",
                      width: "100%",
                    }}
                  >
                    <label htmlFor="Product Name">
                      ชื่อสินค้า (Product Name)
                    </label>
                    <input
                      id="Product Name"
                      value={formik.values.Product_Name}
                      placeholder="กรอก Product Name"
                      style={{
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        padding: "4px 6px",
                      }}
                      onChange={(e) =>
                        formik.setFieldValue("Product_Name", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
              <div style={{ padding: "2px 4px" }}>
                <div style={{ display: "flex", gap: 4 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "16px",
                      width: "100%",
                    }}
                  >
                    <label htmlFor="EOL"> EOL</label>
                    <select
                      id="EOL"
                      value={formik.values.EOL}
                      style={{
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        padding: "4px 6px",
                      }}
                      onChange={(e) =>
                        formik.setFieldValue("EOL", e.target.value)
                      }
                    >
                      <option value={""}>ทั้งหมด</option>
                      <option value={"YES"}>EOL</option>
                      <option value={"NO"}>NO EOL</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              padding: "2px 4px",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "4px",
              gap: "4px",
            }}
          >
            {/* <button
              onClick={() =>
                formik.resetForm({
                  initialValues: {
                    BGroup_ID: null,
                    Brand: null,
                    Model: null,
                    Category: null,
                    Sub_Category: null,
                    Product_Code: "",
                    Product_Name: "",
                  },
                })
              }
              type="reset"
              style={{
                padding: "6px 8px",
                border: "1px solid lightgray",
                borderRadius: "4px",
                backgroundColor: "#e5e7eb",
                color: "#475569",
              }}
            >
              ยกเลิก
            </button> */}
            <button
              type="submit"
              style={{
                padding: "6px 8px",
                border: "1px solid lightgray",
                borderRadius: "4px",
                backgroundColor: "#dcfce7",
                color: "#16a34a",
              }}
            >
              ค้นหา
            </button>
          </div>
          {!!countData && (
            <TableContainer component={Paper} style={{ marginTop: "10px" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      colSpan={3}
                      className="table-header-promotion"
                      style={{ color: "white", backgroundColor: "#bbf7d0" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          justifyContent: "space-between",
                        }}
                      >
                        <p>
                          Rows ทั้งหมด {countData.toLocaleString()} row
                          จำนวนไฟล์ทั้งหมด {ArrayNumber.length.toLocaleString()}{" "}
                          ไฟล์{" "}
                        </p>
                        <button
                          onClick={downloadAll}
                          type="button"
                          style={{
                            padding: "6px 8px",
                            border: "1px solid lightgray",
                            borderRadius: "4px",
                            backgroundColor: "#dcfce7",
                            color: "#16a34a",
                          }}
                        >
                          Download All
                        </button>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableHead>
                  <TableRow>
                    <TableCell
                      className="table-header-promotion"
                      style={{ color: "white", backgroundColor: "#bbf7d0" }}
                    >
                      <Checkbox
                        checked={ArrayNumber.every((res) => !!res.check)}
                        onClick={() =>
                          setArrayNumber((old) =>
                            old.every((res) => !!res.check)
                              ? old.map((res) => ({ ...res, check: false }))
                              : old.map((res) => ({ ...res, check: true }))
                          )
                        }
                      />
                    </TableCell>
                    <TableCell
                      className="table-header-promotion"
                      style={{ color: "white", backgroundColor: "#bbf7d0" }}
                    >
                      ชื่อไฟล์
                    </TableCell>
                    <TableCell
                      className="table-header-promotion"
                      style={{ color: "white", backgroundColor: "#bbf7d0" }}
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ArrayNumber.map((res) => {
                    const name_file = `minday part ${res.number + 1}.xlsx`;
                    return (
                      <TableRow
                        key={`${res.number}-row-download`}
                        className="table-row-promotion"
                      >
                        <TableCell className="table-cell-promotion">
                          <Checkbox
                            checked={!!res.check}
                            onClick={() => {
                              const oldCheck = ArrayNumber[res.number].check;
                              setArrayNumber((old) =>
                                old.map((rez) =>
                                  rez.number == res.number
                                    ? { ...rez, check: !oldCheck }
                                    : { ...rez }
                                )
                              );
                            }}
                          />
                        </TableCell>
                        <TableCell className="table-cell-promotion">
                          {name_file}
                        </TableCell>
                        <TableCell
                          className="table-cell-promotion"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <button
                            onClick={() =>
                              exportExcel({ name_file, index: res.number })
                            }
                            type="button"
                            style={{
                              padding: "6px 8px",
                              border: "1px solid lightgray",
                              borderRadius: "4px",
                              backgroundColor: "#dcfce7",
                              color: "#16a34a",
                            }}
                          >
                            Download
                          </button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Typography>
      </Container>
    </form>
  );
};

export default MinDayPage;
